import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface TimePickerProps {
  rangeMinutes: number;
  setRangeMinutes: React.Dispatch<React.SetStateAction<number>>;
};


export default function ShorthandTimePicker({
   rangeMinutes,
   setRangeMinutes,
   }: TimePickerProps) {
  return (
    <>
      <FormControl sx={{ m: 1, width: 134 }}>
        <InputLabel id='time-range-label-helper'>Time Range</InputLabel>
        <Select
          labelId='time-range-label-helper'
          id='time-range-label'
          value={rangeMinutes}
          label='Time Range'
          onChange={(event: SelectChangeEvent<number>) =>
            setRangeMinutes(Number(event.target.value))
          }
        >
          <MenuItem value={1}>1 Minute</MenuItem>
          <MenuItem value={5}>5 Minutes</MenuItem>
          <MenuItem value={30}>30 Minutes</MenuItem>
          <MenuItem value={60}>1 Hour</MenuItem>
          <MenuItem value={1440}>24 Hours</MenuItem>
          <MenuItem value={10080}>7 Days</MenuItem>
          <MenuItem value={20160}>14 Days</MenuItem>
          <MenuItem value={43830}>1 Month</MenuItem>
          <MenuItem value={131490}>3 Months</MenuItem>
          <MenuItem value={262980}>6 Months</MenuItem>
          <MenuItem value={525960}>1 Year</MenuItem>
          <MenuItem value={1051920}>2 Years</MenuItem>
          <MenuItem value={2629800}>5 Years</MenuItem>
        </Select>
      </FormControl>
    </>
  );
}
